import { RepositorioBase } from "@/http"
import {
  AtividadeDoProjetoCriada,
  CriarAtividadeDoProjeto,
} from "./atividadesDoProjeto.modelos"

class AtividadesDoProjetoRepositorio extends RepositorioBase {
  public criarAtividadeDoProjeto = (
    atividade?: CriarAtividadeDoProjeto
  ): Promise<AtividadeDoProjetoCriada> =>
    this.instance.post("/api/atividades-do-projeto", atividade)
}

export default AtividadesDoProjetoRepositorio
